export const CASA_API_ERROR_MESSAGE = "[Casa api error]: ";

export const EMPTY_CONVERSATION_ID = 0;

export function isEmptyConversation(id: number) {
  return id === EMPTY_CONVERSATION_ID;
}

export const oneDayInMs = 24 * 60 * 60 * 1000;

export let externalFeatures: {
  login: () => void;
  addToCart: ({
    product,
    variant,
    quantity,
  }: {
    product: any;
    variant: any;
    quantity: number;
  }) => Promise<any>;
  trackEvent: (
    eventName: string,
    eventParams: { [key: string]: any }
  ) => Promise<any>;
} = {
  login: () => {
    console.log("Login feature not implemented");
  },
  addToCart: async ({
    product,
    variant,
    quantity,
  }: {
    product: any;
    variant: any;
    quantity: number;
  }) => {
    console.log(
      `Add to cart feature not implemented: ${product.id}, ${variant.id}, ${quantity}`
    );
  },
  trackEvent: async (
    eventName: string,
    eventParams: { [key: string]: any }
  ) => {
    console.log(
      `Track event feature not implemented: ${eventName}, ${JSON.stringify(
        eventParams
      )}`
    );
  },
};

export const FeedbackSentence = "Feedback submitted. Thank you!";
